import { useCallback, useState } from "react";
import { getScheduleById } from "../api/schedulesApi";
import { safeErrorText } from "./scheduleHelpers";

export function useScheduleInlineEdit(editPanelId = "schedule-entry-form") {
  const [editingSchedule, setEditingSchedule] = useState(null);
  const [editError, setEditError] = useState("");

  const openEdit = useCallback(
    async (row) => {
      const id = row?.id;
      if (!id) return;
      setEditError("");
      try {
        const res = await getScheduleById(id);
        const schedule = res?.data;
        if (!schedule?.id) throw new Error("Unable to load schedule for editing");
        setEditingSchedule(schedule);
        requestAnimationFrame(() => {
          document.getElementById(editPanelId)?.scrollIntoView({ behavior: "smooth", block: "start" });
        });
      } catch (err) {
        setEditError(safeErrorText(err, "Failed to open schedule for editing"));
      }
    },
    [editPanelId],
  );

  const openEditById = useCallback(
    async (id) => {
      if (!id) return;
      await openEdit({ id });
    },
    [openEdit],
  );

  const cancelEdit = useCallback(() => {
    setEditingSchedule(null);
    setEditError("");
    requestAnimationFrame(() => {
      document
        .getElementById("schedule-list")
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
      document
        .getElementById("schedule-control-list")
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }, []);

  return {
    editingSchedule,
    editError,
    setEditError,
    openEdit,
    openEditById,
    cancelEdit,
    clearEdit: () => setEditingSchedule(null),
  };
}
